import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Dilucion/eliminarDilucionSeleccion`, method: 'POST', body: {list}, token: token})
}
